import {
  MESSAGE_APPROVAL_STATUSES
} from '../../config/constants'

export default (approvalStatus) => approvalStatus === MESSAGE_APPROVAL_STATUSES.APPROVED



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/is_message_approved.js
 **/